import React, { Component } from 'react'
import { Row, Col, Card, Image, Container } from 'react-bootstrap'
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import moment from 'moment';
import CardLessDataTable from '../../../../neetjee_guru/components/datatables/CardLessDataTableWithSearch';
import DeleteDraftModal from '../../../../neetjee_guru/components/questioners/create_question_paper/DeleteDraftModal';
import '../_exam_made_easy.scss';


const FETCH_SAVED_PAPERS = gql`
  query($institution_id: Int!) {
    getSavedPapers(institution_id: $institution_id) {
        id
        name
        exam_type
        no_of_sets
        start_time
        end_time
        is_completed
        class
        section
        branch
        type
        class_id
        exam_model_id
        is_partexam
        mains_2021
        timestamp
        estatus
        sub_exam_type
        total_question_count
        exam_questions{
            id
            subject
            chapter
            question
            qtype
            option1
            option2
            option3
            option4
            chapter_name
            complexity
            compquestion
            list1type
            list2type
            mat_question
            answer
            inputquestion
        }
    }
  }
`;

const DELETE_DRAFT_PAPER = gql`
  mutation($exam_paper_id: ID) {
    deleteDraftPaper(exam_paper_id: $exam_paper_id)
  }
`;

class DraftQuestionsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deleteModalShow: false,
            curentDeletePaper: '',
            spinnerStatus: "",
        }

    }

    examType = (type) => {
        console.log("type", type);
        if (type == 1) {
            return ("NEET")
        } else if (type == 2) {
            return ("JEE")
        } else if (type == 9 || type == 10 || type == 11) {
            return ("KCET")
        } else {
            return ("EAMCET")
        }
    }

    onClickEdit(paper) {
        let item = {}

        console.log("pppooo", paper);
        this.props.history.push("/exam_made_easy/edit_exam_made_easy/EditExamMadeEasy", {
            edit: true,
            examDetails: paper,
            globals: this.props.globals.globals,
        });
    }

    handleShowModal = (paper) => {
        this.setState({
            deleteModalShow: true,
            curentDeletePaper: paper
        });
    }
    closePopup = () => {
        this.setState({
            deleteModalShow: false
        })
    }

    handleDelete = async () => {
        this.setState({
            spinnerStatus: "1"
        });
        await this.props.deleteDraftPaper({
            variables: {
                exam_paper_id: this.state.curentDeletePaper.id
            },
            update: (store, { data }) => {
                console.log("datadatadatadata", data)
                if (data.deleteDraftPaper == true) {
                    this.setState({
                        is_draft: 0, deleteMessageText: "Deleted Successfully...", spinnerStatus: ""
                    });
                    const data1 = store.readQuery({
                        query: FETCH_SAVED_PAPERS,
                        variables: {
                            institution_id: parseInt(Cookies.get("institutionid"))
                        }
                    });
                    console.log("result.data.getInstituteQuestions", data1);
                    //this.forceUpdate()
                    window.location.reload(true)

                }
            }

        });

    }

    tableData = (savedPapersData) => {
        let getArray = [];

        savedPapersData.map(item => {
            const newObject = {
                exam_name: item.name,
                exam_type: this.examType(item.exam_type),
                no_of_questions: item.total_question_count,
                class_name: item.class,
                branch: item.branch,
                section: item.section,
                date: moment.unix(item.timestamp).format("DD-MM-YYYY LT"),
                edit: <button class="btn btn-primary effect" onClick={() => this.onClickEdit(item)}><i class="fas fa-edit"></i> Edit</button>,
                delete: <button class="btn btn-danger effect" onClick={() => this.handleShowModal(item)}><i class="fas fa-trash"></i> Delete</button>
            }
            getArray.push(newObject);
        })

        return getArray;
    }

    articlecolumns = [
        {
            dataField: "exam_name",
            text: "Exam Name",
            sort: true,
        },
        {
            dataField: "exam_type",
            text: "Exam Type",
        },
        {
            dataField: "no_of_questions",
            text: "No of Questions",
        },
        // {
        //   dataField: "class_name",
        //   text: "class",
        //   sort: true,
        // },
        // {
        //   dataField: "branch",
        //   text: "Branch",
        //   sort: true,
        // },
        // {
        //   dataField: "section",
        //   text: "section",
        //   sort: true,
        // },
        {
            dataField: "date",
            text: "Date & Time",
            sort: true,
        },
        {
            dataField: "edit",
            text: "Edit Paper",
            sort: true,
        },
        {
            dataField: "delete",
            text: "Delete",
            sort: true,
        }
    ];

    render() {
        let savedPapersData = this.props.savedPapers && this.props.savedPapers;

        return (
            <Container fluid className='exam_made_easy'>
                <Row>
                    <Col sm={12}>
                        <Card as={Card.Body} className='block_white'>
                            <div className="d-flex justify-content-between align-items-center">
                                <h5 className="title mb-0">Draft Question Papers</h5>
                                <button
                                    type="button"
                                    onClick={() => this.props.history.push("/exam_made_easy")}
                                    style={{
                                        background: "#3d66f5",
                                        border: "none",
                                        color: "white",
                                        fontWeight: "600",
                                        padding: "10px 20px",
                                        borderRadius: "8px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        cursor: "pointer",
                                    }}
                                >
                                    <i className="fal fa-arrow-left" />
                                    Back
                                </button>
                            </div>
                            <hr />
                            <CardLessDataTable
                                parentData={this.tableData(savedPapersData)}
                                particlecolumns={this.articlecolumns}
                                searchBar={true}
                            />

                        </Card>
                    </Col>
                    <DeleteDraftModal
                        show={this.state.deleteModalShow} onHide={() => this.setState({ deleteModalShow: false })}
                        deletePaper={this.state.curentDeletePaper}
                        spinnerStatus={this.state.spinnerStatus}
                        handleDelete={this.handleDelete}
                        closePopup={this.closePopup}
                    />
                </Row>
            </Container>
        )
    }
}

export default withRouter(
    compose(
        graphql(FETCH_SAVED_PAPERS, {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid"))
                },
                fetchPolicy: 'network-only',
            }),
            name: "getSavedPapers"
        }),
        graphql(DELETE_DRAFT_PAPER, {
            name: "deleteDraftPaper"
        })
    )(DraftQuestionsView)
);